import type { ComponentProps } from 'react';
import { Button } from '@voll-intelligence/ui-kit/ui/button';
import { CardFooter } from './card_footer.js';

/*
 * Os botões da saia do calendário (Figma 16/10, #5246), compartilhados pelas cascas
 * que a desenham: o popover do QUANDO (layout aberto, faixa e colapsado) e a folha
 * do celular. São o `Button` do DS no degrau de toque `xl` (44px); a casca só passa
 * forma e largura (a folha os quer em pílula). `genui2` no próprio botão: o card não
 * vive sob a raiz de tema do DS (mesma razão do `InlineSearchCta`).
 */
/** `className` só string: forma e largura da casca, nunca a função de estado do Base UI. */
type SkirtButtonProps = Omit<ComponentProps<typeof Button>, 'size' | 'variant' | 'className'> & {
  readonly className?: string;
};

export function SkirtConfirm({ className, ...props }: SkirtButtonProps) {
  return <Button type="button" size="xl" className={`genui2 ${className ?? ''}`} {...props} />;
}

export function SkirtReset({ className, ...props }: SkirtButtonProps) {
  return (
    <Button
      type="button"
      variant="ghost"
      size="xl"
      className={`genui2 bg-transparent ${className ?? ''}`}
      {...props}
    />
  );
}

/** O rodapé do popover: o fio de 1px (ink a 10%) com 16 acima e abaixo. Acima são
 *  6 aqui porque o `.fpl-pop` já põe 10 entre os filhos. */
export const SKIRT_FOOT = 'mt-1.5 gap-4 border-sand-12/10 bg-transparent px-0 pt-4 pb-0';
/** Os botões do popover à direita, 24 entre eles. */
export const SKIRT_ACTIONS = 'justify-end gap-6';

/**
 * A saia do popover de datas do layout aberto (#2136): Redefinir + Confirmar,
 * SÓ no intervalo (ida e volta) — é o par de popover do benchmark (Navan, Kiwi,
 * Mindtrip). Confirmar FECHA e responde o QUANDO (`onConfirm`): no
 * preenchimento guiado, com a rota dada, é a busca (#4620, "Confirmar e
 * buscar" — na conversa, enviar a mensagem); fora dele, o Buscar segue sendo o
 * disparo. Redefinir limpa sem fechar: a grade é onde se escolhe de novo.
 * Fábrica do render do `footer` (recebe o `close` do popover).
 */
export function datesSkirt({
  hasOutbound,
  confirmDisabled,
  confirmLabel,
  resetLabel,
  resetDates,
  onConfirm,
}: {
  readonly hasOutbound: boolean;
  readonly confirmDisabled: boolean;
  readonly confirmLabel: string;
  readonly resetLabel: string;
  readonly resetDates: () => void;
  readonly onConfirm: () => void;
}) {
  return (close: () => void) => (
    <CardFooter className={SKIRT_FOOT}>
      <div className={`fui-actions ${SKIRT_ACTIONS}`}>
        {hasOutbound && <SkirtReset onClick={resetDates}>{resetLabel}</SkirtReset>}
        <SkirtConfirm
          disabled={confirmDisabled}
          onClick={() => {
            close();
            onConfirm();
          }}
        >
          {confirmLabel}
        </SkirtConfirm>
      </div>
    </CardFooter>
  );
}
